import {useSelector} from 'react-redux'
import {SidebarCustomerMenu} from './customer/SidebarCustomerMenu'
import {getCommonState} from '../../../redux/commonSlice'
import {getCompanyState} from '../../../redux/companySlice'
import {getUserState} from '../../../redux/userSlice'
import SidebarName from './SidebarName'
import SidebarLogoutButton from './SidebarLogoutButton'
import SidebarEmail from './SidebarEmail'
import AdminSiderBarMenu from './admin/AdminSiderBarMenu'

const SidebarMenuMain = () => {
  const userState = useSelector(getUserState)
  const companyState = useSelector(getCompanyState)
  const commonState = useSelector(getCommonState)

  return (
    <>
      <div className='menu-item'>
        <div className='aside-toolbar flex-column-auto' id='kt_aside_toolbar'>
          <div className='aside-user justify-content-stretch'>
            <div className='symbol symbol-50px w-100'>
              <div className='aside-user-info flex-row-fluid flex-wrap ms-5'>
                <div className='d-flex'>
                  <SidebarName />
                  <SidebarLogoutButton />
                </div>
                <div className='d-flex'>
                  <SidebarEmail />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {commonState.isGeneralDataLoaded && (
        <>{process.env.REACT_APP_ENV?.includes('ADMIN') == false && <SidebarCustomerMenu />}</>
      )}

      {process.env.REACT_APP_ENV?.includes('ADMIN') == true && <AdminSiderBarMenu />}

      {/* {(userState.data?.roleId == UserTypeEnum.Admin ||
        userState.data?.roleId == UserTypeEnum.Satışçı) &&
        window.location.pathname == '/admin-potentials' && <SidebarAdminPotentialCustomersMenu />}

      {userState.data?.roleId == UserTypeEnum.Admin &&
        window.location.pathname == '/admin-dashboard' && <SidebarAdminDashboardMenu />} */}
    </>
  )
}

export {SidebarMenuMain}
